import {
  FormWindow,
  Tittle,
  FormInput,
  FormButton,
  FormTextarea
} from './styled.js'
import { useRef } from 'react'
import emailjs from '@emailjs/browser'

const Form = () => {
  const form = useRef()
  const sendEmail = e => {
    e.preventDefault()

    emailjs
      .sendForm(
        'service_73v1dbe',
        'template_ykjza4n',
        form.current,
        'OYPwnGh30hFauC9Yz'
      )
      .then(
        () => {
          alert('Wiadomość została wysłana!')
          form.current.reset()
        },
        error => {
          alert('Wystąpił błąd:' + error.text)
        }
      )
  }
  return (
    <FormWindow ref={form} onSubmit={sendEmail}>
      <Tittle>Formularz Kontaktowy</Tittle>
      <FormInput name='from_name' placeholder='Imię i nazwisko' required />
      <FormInput name='reply_to' placeholder='E-mail' required />
      <FormInput name='size' placeholder='Rozmiar pieluszki' required />
      <FormTextarea name='message' placeholder='Wiadomość' required />
      <FormButton type='submit'>Wyślij wiadomość</FormButton>
    </FormWindow>
  )
}

export default Form
